const count = (value) => Number(value || 0).toLocaleString();
const percent = (value) => value == null ? 'N/A' : `${(Number(value) * 100).toFixed(1)}%`;

export function safetyInsightRows(insights) {
  if (!insights) return [];
  const ack = insights.acknowledgements || {};
  return [
    ['Event-free drivers', `${count(insights.eventFreeDrivers)} / ${count(insights.observedDrivers)}`, 'Drivers with valid mileage and no recorded road events.'],
    ['Safety notice participation', percent(ack.rate), 'Acknowledged safety notices divided by delivered notices.'],
    ['Severe driving events', count(insights.severeEvents), 'Severe events across all four road behaviors.'],
    ['Severe-event share', percent(insights.severeEventShare), 'Share of recorded road events classified as severe.'],
    ['Severe speeding', count(insights.severeSpeedingEvents), 'Speeding events classified as severe.'],
    ['Time spent speeding', `${Number(insights.speedingMinutes || 0).toFixed(1)} min`, 'Combined duration of recorded speeding events.'],
    ['Drivers for coaching review', count(insights.repeatEventDrivers), 'Drivers with 3+ events of the same type in this period.'],
    ['Safety notice follow-up', count(ack.pending), 'Delivered safety notices awaiting acknowledgement.'],
  ];
}

export const SAFETY_INSIGHTS_NOTE = 'Insights cover the selected period and driver, across all road event types. Severe events are included in road-event totals. Event-free means no recorded events; consider mileage and coverage when reviewing results.';
